import { MenuItemType } from '@components';
import {
  saveReferenceNumbers,
  setLtlReferenceNumberStore,
} from '@store/ltl/store';
import { setOrderStore, TrySaveOrder } from '@store/orders';
import {
  validateOrder,
  validateReferenceNumbers,
} from '@utils/validationUtils';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

export const getMenuItems = (lockEnabled: boolean): MenuItemType[] => {
  return [
    { label: 'Copy Order', value: 'Copy Order' },
    { label: 'Copy Multiple', value: 'Copy Multiple' },
    {
      label: 'Save As Template',
      value: 'Save As Template',
      disabled: lockEnabled,
    },
    {
      label: 'Add Billing Hold/Note',
      value: 'Add Billing Hold/Note',
      disabled: lockEnabled,
    },
    { label: 'Void Order', value: 'Void Order', disabled: lockEnabled },
  ];
};

type NavigateFunction = (to: string) => void;

export const handleHeaderSave = async (
  navigate?: NavigateFunction,
  ltlQuoteId?: string,
) => {
  const hasReferenceNumberChanges = validateReferenceNumbers();
  if (hasReferenceNumberChanges) {
    setLtlReferenceNumberStore('isSaving', true);
  }
  let saved = false;
  try {
    const shouldSaveOrder = Boolean(validateOrder());
    if (shouldSaveOrder) {
      saved = await TrySaveOrder(navigate, ltlQuoteId);
    }
    if (hasReferenceNumberChanges) {
      const referenceNumbersSaved = await saveReferenceNumbers(
        CHANGE_TRACKING_SOURCES.orderDetails.loadDetails,
      );
      saved = shouldSaveOrder
        ? saved && referenceNumbersSaved
        : referenceNumbersSaved;
    }
  } finally {
    setLtlReferenceNumberStore('isSaving', false);
  }
  setOrderStore('resetDirty', true);
  setTimeout(() => {
    setOrderStore('resetDirty', false);
  }, 0);
  return saved;
};
